import { useState } from "react";
import { ArrowLeft, Clock, BookOpen, PlayCircle } from "lucide-react";
import { C } from "../../theme/tokens";
import { LessonPdfScreen } from "./LessonPdfScreen";

export function CourseDetailScreen({ course, t, onBack, wide, user, authFetch }) {
  // { id, title, videoLink } of the currently open lesson, or null.
  const [openLesson, setOpenLesson] = useState(null);

  if (openLesson) {
    return (
      <LessonPdfScreen
        lesson={openLesson}
        user={user}
        authFetch={authFetch}
        t={t}
        wide={wide}
        onBack={() => setOpenLesson(null)}
      />
    );
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: wide ? "0" : "20px 16px 0",
        }}
      >
        <button
          onClick={onBack}
          style={{
            width: 34,
            height: 34,
            borderRadius: 10,
            border: `1px solid ${C.hairline}`,
            background: C.panel1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <ArrowLeft size={16} color={C.primary} />
        </button>
        <div
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 600,
            fontSize: 14.5,
            color: C.primary,
          }}
        >
          {t.edu_about}
        </div>
        <div style={{ width: 34 }} />
      </div>

      <div style={{ padding: wide ? "18px 0 0" : "18px 20px 0", maxWidth: wide ? 720 : undefined }}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            background: C.panel1,
            border: `1px solid ${C.hairline}`,
            borderRadius: 20,
            padding: "6px 12px",
            fontSize: 12,
            color: C.primary,
          }}
        >
          <Clock size={13} color={C.secondary} /> {course.duration}
        </div>

        <div
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 700,
            fontSize: wide ? 30 : 25,
            color: C.primary,
            marginTop: 12,
            letterSpacing: "-0.01em",
          }}
        >
          {course.title}
        </div>

        <div style={{ display: "flex", gap: 16, marginTop: 10 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, color: C.eduBright, fontSize: 13, fontWeight: 600 }}>
            <BookOpen size={15} /> {course.lessons.length} {t.edu_lesson_word}
          </div>
        </div>

        <p style={{ color: C.secondary, fontSize: 13.5, lineHeight: 1.55, marginTop: 14 }}>
          {course.about}
        </p>
      </div>

      <div
        style={{
          marginTop: 22,
          background: wide ? "transparent" : C.canvas,
          borderTop: wide ? "none" : `1px solid ${C.hairline}`,
          borderTopLeftRadius: wide ? 0 : 22,
          borderTopRightRadius: wide ? 0 : 22,
          padding: wide ? "18px 0 24px" : "18px 20px 24px",
          maxWidth: wide ? 900 : undefined,
        }}
      >
        <div
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 700,
            fontSize: 15.5,
            color: C.primary,
            marginBottom: 12,
          }}
        >
          {t.edu_program}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {course.lessons.map((lesson) => (
            <button
              key={lesson.id}
              onClick={() => setOpenLesson({ id: lesson.id, title: lesson.title, videoLink: lesson.videoLink, hasVideo: lesson.hasVideo })}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                background: C.panel1,
                border: `1px solid ${C.hairline}`,
                borderRadius: 20,
                padding: "12px 14px",
                width: "100%",
                textAlign: "left",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: 9,
                  background: `linear-gradient(135deg, ${C.edu} 0%, ${C.eduBright} 100%)`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <PlayCircle size={15} color="#241705" />
              </span>
              <span style={{ fontSize: 13.5, color: C.primary, fontWeight: 500 }}>{lesson.title}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}